// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { PostApiMediaData, PostApiMediaResponse } from './types.gen';

/**
 * Upload a new media entry with variants
 * Uploads a new media entry with pre-processed small and large variants.
 * @param data The data for the request.
 * @param data.formData
 * @returns MediaResponse Successful upload of the media variants.
 * @throws ApiError
 */
export const postApiMedia = (data: PostApiMediaData): CancelablePromise<PostApiMediaResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/media',
        formData: data.formData,
        mediaType: 'multipart/form-data',
        errors: {
            400: 'Bad request (e.g., invalid file size, missing required variant)',
            415: 'Unsupported media type',
            500: 'Internal server error'
        }
    });
};